import { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { change, getFormValues } from 'redux-form';

import CommunityPostFormComponent from './CommunityPostFormComponent';

import { onModalClose } from '../../Modal/actions';
import { createPost, getPostsList, updatePost } from '../actions';

const form = 'CommunityPost';

const CommunityPostFormContainer = (props) => {
  const {
    currentCommunityId,
    createPost,
    updatePost,
    onModalClose,
    type,
    onGetPostsList,
    queryParams,
    post,
    isFreeItem,
    imagesCount,
    onFieldChange,
  } = props;

  useEffect(() => {
    isFreeItem && onFieldChange('price', '0.00');
  }, [isFreeItem]);

  const { id: postId, subject, price, text, photos } = post || {};

  const initialValues = postId && {
    subject,
    price,
    text,
    images: photos,
    free: Number(price) === 0,
  };

  const onPostSubmit = async (values) => {
    const { price, free, images, ...rest } = values;
    const data = {
      ...rest,
      price: free ? 0 : price,
      community: currentCommunityId,
      type,
      images: images?.filter((img) => img instanceof File),
    };

    if (postId) {
      const res = await updatePost(postId, data);
      if (!res) return;
      onModalClose();
    } else {
      const res = await createPost(data);
      if (!res) return;
      onGetPostsList(queryParams, true);
      onModalClose();
    }
  };

  return (
    <CommunityPostFormComponent
      form={form}
      onModalClose={onModalClose}
      onPostSubmit={onPostSubmit}
      type={type}
      isFreeItem={isFreeItem}
      imagesCount={imagesCount}
      initialValues={initialValues}
      isUpdate={Boolean(postId)}
    />
  );
};

CommunityPostFormContainer.propTypes = {
  createPost: PropTypes.func.isRequired,
  updatePost: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onGetPostsList: PropTypes.func.isRequired,
  currentCommunityId: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  isFreeItem: PropTypes.bool.isRequired,
  queryParams: PropTypes.instanceOf(Object),
  post: PropTypes.instanceOf(Object),
  imagesCount: PropTypes.number,
};

const mapStateToProps = (state) => ({
  isFreeItem: Boolean(getFormValues(form)(state)?.free),
  imagesCount: getFormValues(form)(state)?.images?.length,
});

const mapDispatchToProps = (dispatch) => ({
  onGetPostsList: (queryParams, isClearPrev) =>
    getPostsList(dispatch, queryParams, { isClearPrev }),
  createPost: (data) => createPost(dispatch, data),
  updatePost: (postId, data) => updatePost(dispatch, postId, data),
  onModalClose: () => onModalClose(dispatch),
  onFieldChange: (field, value) => dispatch(change(form, field, value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunityPostFormContainer);
